import { render, staticRenderFns } from "./Audio3D.vue?vue&type=template&id=0e34a4ae&"
import script from "./Audio3D.vue?vue&type=script&lang=js&"
export * from "./Audio3D.vue?vue&type=script&lang=js&"
import style0 from "./Audio3D.vue?vue&type=style&index=0&id=0e34a4ae&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports